import { DashboardWidget } from "../../../models/workspace";
import {
  ChartOldWidgetKey,
  MidstreamChartOldWidgetKey
} from "../constants/widgets.constants";

export const getSessionData = (widget: DashboardWidget) => {
  let sessionData: string;
  // Keep logic for old chart widget types for backward compatibility
  if (widget.type === ChartOldWidgetKey) {
    sessionData = sessionStorage.getItem(`chart::${widget.widgetId}`);
  } else if (widget.type === MidstreamChartOldWidgetKey) {
    sessionData = sessionStorage.getItem(`midstream-chart::${widget.widgetId}`);
  } else {
    sessionData = sessionStorage.getItem(`${widget.type}::${widget.widgetId}`);
  }
  return sessionData;
};
